import React, { Fragment } from 'react';
import OurBooks from '../../components/OurBooks/OurBooks';
import Header from '../../components/Header/Header';
import ScrollTo from "../../helpers/scroll";
import Footer from '../../components/Footer/Footer';
import BackToTop from '../../components/BackToTop/BackToTop';

export default class Store extends React.Component {

    constructor(props) {
        super(props);
        // window.scrollTo(0,0);
    }

    componentDidMount() {
      const element = document.querySelector(`#OurBooks`);
      const to = element.offsetTop;
          window.scroll({
              top: to - 0,
              behavior: "smooth"
          });
    }
    render() {
        return (
            <Fragment>
                <Header   history={this.props.history} />
                <OurBooks history={this.props.history} />
                <Footer   history={this.props.history}/>
                <BackToTop/>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Store/index.js